import { Hero } from "../../common/Hero"
import { Section } from "../../common/Section"
import styles from "./Home.module.css"
import { ParallaxBanner } from "react-scroll-parallax"

export const Home = () => {
  return (
    <div className={styles.root}>
      <Hero />
      <ParallaxBanner
        layers={[
          {
            image:
              "https://portfolio-demos-1.s3.eu-west-2.amazonaws.com/bg-sun.jpg",
            speed: 30,
          },
        ]}
        className={styles.banner}
      >
        <Section
          img={{
            src: "https://portfolio-demos-1.s3.eu-west-2.amazonaws.com/japan.jpeg",
            alt: "Michael Tandy - Senior Frontend Developer",
          }}
          id='technology'
        >
          <h2>Technology</h2>
          <p>
            I primarily work with React, Typescript and adjacent technologies
            within the JS ecosystem.
          </p>
          <p>
            I am first and foremost a frontend expert with a keen interest in
            design and user experience. Nevertheless, I am a T-shaped developer
            and have a broad base of knowledge which enables my work on the
            frontend. My skills and experience range from design tools like
            Figma to backend technologies like Node.js and Java.
          </p>
          <ul>
            <li>
              React, Next, Vue, Angular, JavaScript (ES6+), TypeScript,
              Accessibility, Performance
            </li>
            <li>
              Node.js / Express, REST, Microservices Java, Spring Boot MongoDB /
              Postgres
            </li>
            <li>Docker</li>
            <li>HTML, CSS, Sass, Styled Components</li>
            <li>Component Libraries - Bootstrap, MUI, Ant Design etc</li>
            <li>Storybook</li>
            <li>Figma</li>
            <li>
              Design Systems / Primitives / Composable Components - Radix UI
            </li>
            <li>Git</li>
            <li>Agile (Scrum, Kanban)</li>
            <li>
              TDD, Jest, Vitest, Testing Library, Cypress (Unit, Integration,
              E2E Testing)
            </li>
            <li>CI/CD, Github Actions, Husky, ESLint</li>
          </ul>
        </Section>
      </ParallaxBanner>

      <Section
        img={{
          src: "https://portfolio-demos-1.s3.eu-west-2.amazonaws.com/industry.jpeg",
          alt: "Automotive Phone Application",
        }}
        altLayout
        id='industry'
      >
        <h2>Industry</h2>
        <p>
          I have a broad base of experience within the software industry,
          ranging across Software as a Service, Platform as a Service, Gaming,
          Consultancy and Agency environments.
        </p>
        <p>
          Wherever I work, I promote improvements to software development and
          project workflows. I believe in the principles descibed in Clean Agile
          (2019) - collaboration, craftsmanship, and rapid, reliable delivery of
          high-quality software.
        </p>
        <p>My industry projects have included:</p>
        <ul>
          <li>
            Developing and maintaining web applications that support a globally
            recognised online game with millions of active players, optimising
            for performance, scalability, and user experience in a high-traffic
            environment.
          </li>
          <li>
            Leading the frontend development of critical scheduling features for
            a major automotive company's flagship Software as a Service (SaaS)
            platform.
          </li>
          <li>
            Building intuitive, responsive interfaces for a Platform as a
            Service (PaaS) to visualise Kubernetes workload scaling, manage
            deployments, and monitor resource usage in real time.
          </li>
          <li>
            Delivering a variety of commercial projects for a web agency
            including corporate websites, ecommerce stores, and custom web apps,
            ensuring consistent UX/UI standards across projects.
          </li>
        </ul>
      </Section>

      <ParallaxBanner
        layers={[
          {
            image:
              "https://portfolio-demos-1.s3.eu-west-2.amazonaws.com/bg4.jpg",
            speed: 30,
          },
        ]}
        className={styles.banner3}
      >
        <Section
          img={{
            src: "https://portfolio-demos-1.s3.eu-west-2.amazonaws.com/philosophy.jpeg",
            alt: "Japan",
          }}
          id='philosophy'
        >
          <h2>Development Philosophy</h2>
          <p>
            I am an advocate of the principles described in Clean Code (2008) by
            Bob Martin. These are:
          </p>
          <ol>
            <li>
              <span>Meaningful Names</span> - Use descriptive, unambiguous names
              for variables, functions, and classes that reveal their intent.
            </li>
            <li>
              <span>Small Functions</span> - Keep functions short and focused on
              a single task. They should do one thing and do it well.
            </li>
            <li>
              <span>Readable Code</span> - Write code for humans to read first,
              machines second. Clear, simple, and straightforward beats clever
              or complex.
            </li>
            <li>
              <span>Avoid Duplication</span> - Duplicated code leads to bugs and
              maintenance headaches. Extract common logic to reusable functions
              or classes.
            </li>
            <li>
              <span>Clear Comments</span> - Comments should explain why
              something is done, not what the code does—ideally, the code itself
              should be self-explanatory.
            </li>
            <li>
              <span>Consistent Formatting</span> - Maintain a consistent style
              for indentation, spacing, and braces to improve readability and
              reduce cognitive load.
            </li>
            <li>
              <span>Error Handling</span> - Handle errors gracefully and
              clearly; avoid cluttering core logic with error checks by using
              exceptions or other clean patterns.
            </li>
            <li>
              <span>Write Tests</span> - Automated tests (especially unit tests)
              ensure code correctness and enable safe refactoring.
            </li>
            <li>
              <span>Refactor Continuously</span> - Keep code clean and flexible
              by regularly improving its structure without changing behavior.
            </li>
            <li>
              <span>Avoid Premature Optimization</span> - Focus first on clarity
              and correctness; optimize only when necessary and backed by
              measurement.
            </li>
          </ol>
        </Section>
      </ParallaxBanner>
      <Section
        img={{
          src: "https://portfolio-demos-1.s3.eu-west-2.amazonaws.com/kazakhstan2.jpeg",
          alt: "Michael Tandy - Senior Frontend Developer",
        }}
        altLayout
        id='about'
      >
        <h2>About Me</h2>
        <p>
          I am based in Cardiff and enjoy science fiction, contemporary art,
          architecture, languages, video games and travelling the world!
        </p>
        <p>
          Please contact me by emailing me at{" "}
          <a href='mailto:miketandy@protonmail.com'>miketandy@protonmail.com</a>{" "}
          or calling me on <a href='tel:07769583616'>07769 583 616</a>
        </p>
        <p>Mike</p>
      </Section>
    </div>
  )
}
